/* eslint-disable react/prop-types */
export default function AuthShell({ title, description, children }) {
    return (
        <main className="auth-shell relative min-h-screen bg-zinc-950 text-white">
            <div className="auth-glow pointer-events-none absolute inset-0" aria-hidden="true" />
            <div className="relative mx-auto flex min-h-screen max-w-6xl items-center justify-center px-4 pb-12 pt-24">
                <section aria-labelledby="auth-title" className="w-full max-w-md rounded-3xl border border-zinc-800 bg-zinc-900/65 p-6 shadow-[0_20px_60px_rgba(0,0,0,0.35)] backdrop-blur-sm sm:p-8">
                    <h1 id="auth-title" className="text-3xl font-bold">{title}</h1>
                    <p className="mt-2 text-sm text-zinc-300">{description}</p>
                    <div className="mt-7">{children}</div>
                </section>
            </div>
        </main>
    );
}
